import { fetchAPIData } from "./DataFetchers";

export async function fetchAlertsForProject(projectID) {
    if (projectID === null || projectID === undefined) return;

    const baseURL = `https://data.clistek.io/api/${projectID.replace("p:","")}/eval/?expr=`;
    const expr = `readAll(eAlertRec)`;

    const apiData = await fetchAPIData(baseURL, expr, false);

    // logger.debug("alert project data", apiData);
    if (!apiData || apiData.cols === undefined || apiData.rows === undefined)
      return null;

    // extract table rows
    let mappedAlerts =
      apiData && apiData.rows && apiData.rows.length > 0
        ? apiData.rows.map((item) => ({
            value: item?.id?.val,
            name: item?.dis,
          }))
        : [];

    // logger.debug("mappedAlerts", mappedAlerts);
    return mappedAlerts;
}